import { PlanogramShelf } from "@CommonTypes/merchflow/pog/shelf";
import { DraggedItemsPayload } from "./store/types";
import { Flex } from "src/elements";
import styled from "styled-components";

const DropperElement = styled(Flex)<{
  side: DropperSide;
  shelfType: PlanogramShelf["type"];
}>`
  flex-grow: ${({ side }) => side === "static" && "1"};
  position: ${({ side }) => side !== "static" && "absolute"};
  left: ${({ side }) => side !== "right" && "0"};
  right: ${({ side }) => side === "right" && "0"};
  bottom: ${({ shelfType, bottom }) => shelfType !== "HANGCELL" && bottom};
  top: ${({ shelfType, bottom }) => shelfType === "HANGCELL" && bottom};
`;

type DropperSide = "left" | "right" | "static";

interface Props {
  side: DropperSide;
  width: string;
  height: string;
  bottom?: string;
  shelfType?: PlanogramShelf["type"];
  onDropOver: () => void;
  onDrop: (payload: DraggedItemsPayload) => void;
}

export const Dropper = ({
  side,
  width,
  height,
  bottom = "0",
  shelfType = "REGULAR",
  onDropOver,
}: Props) => {
  return (
    <DropperElement
      className="item-dropper"
      side={side}
      width={width}
      height={height}
      bottom={bottom}
      shelfType={shelfType}
      onPointerEnter={onDropOver}
    />
  );
};
